export default __webpack_public_path__ + "static/media/clock.62d7a6d2.svg";